import { useEffect } from 'react'
import { useAuth } from '@orisini/ui/context/AuthContext'

/**
 * Gerbang sesi Gramium.
 *
 * Berbeda dari orisini.com, di sini pengunjung yang belum masuk TIDAK dibawa ke
 * route internal — Gramium tidak punya halaman masuk. Ia dilempar ke
 * orisini.com dengan `?next=` supaya kembali ke halaman yang sama setelah
 * berhasil masuk.
 *
 * Memakai window.location, bukan <Navigate>, karena tujuannya origin lain.
 */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status, loginUrl } = useAuth()

  useEffect(() => {
    if (status === 'anonymous') {
      window.location.replace(loginUrl())
    }
  }, [status, loginUrl])

  if (status !== 'authenticated') {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        {status === 'loading' ? 'Loading…' : 'Redirecting to sign in…'}
      </div>
    )
  }

  return <>{children}</>
}
